import {
	defAction
}from "../../../../helpers/defaultAction"
import api from './api'
import {
	rePossibleCharacteristicConstants
}from "./constants"

export const rePossibleCharacteristicActions = {
	getList,
	getPaged,
	getPagedAll,
	getPagedAudit,
	create,
	remove,
	update,
	restore,
	clear
}

function getList(values){
	const dispatchObj = {
		constants : rePossibleCharacteristicConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPaged(values){
	const dispatchObj = {
		constants : rePossibleCharacteristicConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAll(values){
	const dispatchObj = {
		constants : rePossibleCharacteristicConstants.GetPagedAll,
		service   : {
			func   : api.getPagedAll,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAudit(values){
	const dispatchObj = {
		constants : rePossibleCharacteristicConstants.GetPagedAudit,
		service   : {
			func   : api.getPagedAudit,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : rePossibleCharacteristicConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : rePossibleCharacteristicConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restore(values){
	const dispatchObj = {
		constants : rePossibleCharacteristicConstants.Restore,
		service   : {
			func   : api.restore,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : rePossibleCharacteristicConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: rePossibleCharacteristicConstants.CLEAR
	})
}
